import React, { useRef, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ForgotPasswordSecond } from "./ForgotPasswordSecond";
import { disRememberApi } from "../../../api";
import { useTranslation } from "react-i18next";
import { Alert } from "../../../shared";
import "./LoginFlat.css";
import { ThemeLanguageToggle } from "./ThemeLanguageToggle";

const ForgotPassword = () => {
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const { t } = useTranslation();
  const [next, setNext] = useState(false);
  const form = useRef(null);
  const initialLoginValues = {
    email: "",
  };

  const submitLoginForm = () => {
    const data = new FormData(form.current);
    disRememberApi(data)
      .then(() => {
        setNext(!next);
      })
      .catch(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("کاربری با این ایمیل یافت نشد!"),
          type: "Error",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 5000);
      });
  };

  const validationSchemaLogin = Yup.object({
    email: Yup.string()
      .required(t("ایمیل را وارد کنید"))
      .email(t("ایمیل را طبق فرمت وارد کنید")),
  });

  return (
    <div className="login-flat-container">
      {/* Theme and Language Controls */}
      <ThemeLanguageToggle />
      
      <div className="login-flat-card">
        {!next ? (
          <>
            {/* Header Section */}
            <div className="login-flat-header">
              <div className="login-flat-icon-wrapper">
                <svg className="login-flat-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6H9C9 4.34 10.34 3 12 3C13.66 3 15 4.34 15 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM18 20H6V10H18V20ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17Z" fill="currentColor"/>
                </svg>
              </div>
              <h2 className="login-flat-title">{t("رمز عبور خود را فراموش کردید؟")}</h2>
              <p className="login-flat-subtitle">
                {t("لطفا ایمیل خود را در زیر وارد کنید تا دستورالعمل های تنظیم مجدد رمز عبور خود را دریافت کنید")}
              </p>
            </div>
            
            {/* Form Section */}
            <div className="login-flat-form">
              <Formik
                initialValues={initialLoginValues}
                onSubmit={submitLoginForm}
                validationSchema={validationSchemaLogin}
              >
                {(props) => (
                  <Form ref={form}>
                    {/* Email Input */}
                    <div className="login-flat-input-group">
                      <div className="login-flat-input-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="currentColor"/>
                        </svg>
                      </div>
                      <input
                        type="email"
                        placeholder={t("ایمیل")}
                        name="email"
                        className="login-flat-input"
                        onChange={props.handleChange}
                        onBlur={props.handleBlur}
                      />
                      <ErrorMessage name="email">
                        {(errMsg) => (
                          <div className="login-flat-error">{errMsg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                    
                    <button type="submit" className="login-flat-button">
                      {t("ادامه")}
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </>
        ) : (
          <ForgotPasswordSecond />
        )}
      </div>
      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </div>
  );
};

export { ForgotPassword };
